import { CardsGrid } from '@app/components/base/content-structure/CardsGrid';
import { CardsGridItem } from '@app/components/base/content-structure/CardsGridItem';
import {
  CARDS_GRID_DENSE_COLUMNS,
  CARDS_GRID_DENSE_COLUMN_SPACING,
} from '@app/components/base/content-structure/cards-grid-config';
import { YoutubeBroadcastCardSkeleton } from '../card/YoutubeBroadcastCardSkeleton';
import {
  YOUTUBE_BROADCASTS_GRID_ITEM_SIZE,
  YOUTUBE_BROADCASTS_GRID_SKELETON_COUNT,
} from './youtube-broadcasts-grid-constants';

/** Skeleton grid shown while YouTube broadcasts are loading. */
export function YoutubeBroadcastsGridSkeleton() {
  return (
    <CardsGrid columns={CARDS_GRID_DENSE_COLUMNS} columnSpacing={CARDS_GRID_DENSE_COLUMN_SPACING}>
      {Array.from({ length: YOUTUBE_BROADCASTS_GRID_SKELETON_COUNT }).map((_, i) => (
        <CardsGridItem size={YOUTUBE_BROADCASTS_GRID_ITEM_SIZE} key={i}>
          <YoutubeBroadcastCardSkeleton />
        </CardsGridItem>
      ))}
    </CardsGrid>
  );
}
